// import { SectionTitle } from '../common';
import { ScrollSectionTitle } from '@components/scroll-section-title';
import { MediaField } from '../content-media';
import ContactsIcon from '@material-ui/icons/Contacts';
import { scrollToElement, withScrollSpyItem } from '@components/scroll-spy';
import { blue, green, indigo } from '@material-ui/core/colors';
import { Divider, Grid, Typography } from '@material-ui/core';
import { useFormContext, useWatch } from 'react-hook-form';
// import { forwardRef, useCallback, useRef } from 'react';
// import { CompanyServiceField } from '../fields';
import { useRecentGetter } from '@lib/common';
import { useSubject } from '@lib/common/hooks/use-subject';
import { useSubscription } from '@lib/common/hooks/use-subscription';
import { useEffect } from 'react';
import { debounceTime, filter, pairwise, map, startWith } from 'rxjs/operators';
// import { useInsightActions } from '../service-insights';
import { CompanyMasters } from '@api/masters';

export const MediaSection = () => {
  const { control } = useFormContext();

  return (
    <>
      <ScrollSectionTitle
        id="content-media"
        subTitle="Information about Content Media"
        icon={sectionIcon}>
        Media Details
      </ScrollSectionTitle>
      <Divider />
      {/* <SectionTitle
        id="company-associated-persons"
        title="Company Associated Person"
        subTitle="Information about Associated Person"
        icon={sectionIcon}
      />
      <Divider /> */}
      <br />
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <MediaField control={control} name="media_details" />
        </Grid>
      </Grid>
    </>
  );
};

const sectionIcon = <ContactsIcon fontSize="large" style={{ color: blue[600] }} />;

interface TitleProps {
  title: React.ReactNode;
  subTitle: React.ReactNode;
  icon: React.ReactNode;
}

const SectionTitle = withScrollSpyItem(
  ({ title, icon, subTitle, id }: TitleProps & { id: string }, ref: any) => (
    <Grid container ref={ref} id={id} spacing={2} alignItems="center">
      <Grid item>{icon}</Grid>
      <Grid item>
        <Typography variant="h5">{title}</Typography>
        <Typography color="textSecondary" variant="body2">
          {subTitle}
        </Typography>
      </Grid>
    </Grid>
  )
);
